/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * 
 * @export
 * @interface ServiceAppointment
 */
export interface ServiceAppointment {
  _id?: string;
    /**
     * 
     * @type {Date}
     * @memberof ServiceAppointment
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ServiceAppointment
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof ServiceAppointment
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceAppointment
     */
    storeId: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceAppointment
     */
    serviceForm: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceAppointment
     */
    submission?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceAppointment
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceAppointment
     */
    patientName: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceAppointment
     */
    patientEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceAppointment
     */
    patientPhone?: string;
    /**
     * Appointment day (YYYY-MM-DD)
     * @type {Date}
     * @memberof ServiceAppointment
     */
    date: Date;
    /**
     * Slot start time HH:MM
     * @type {string}
     * @memberof ServiceAppointment
     */
    timeSlot: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceAppointment
     */
    status: ServiceAppointmentStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum ServiceAppointmentStatusEnum {
    Booked = 'Booked',
    Cancelled = 'Cancelled',
    Completed = 'Completed'
}

